import React, { Component } from "react";
import { TextField } from "office-ui-fabric-react/lib/TextField";
import { Mutation } from "react-apollo";
import gql from "graphql-tag";

class LoadingOrderField extends Component {
  state = {
    active: false,
    value: ""
  };

  render() {
    const { item } = this.props;
    return (
      <Mutation mutation={UPDATE_LOADING_ORDER}>
        {(mutate, { m_data }) => (
          <div
            onClick={e => {
              e.preventDefault();
              this.setState({ active: true });
            }}
            onMouseLeave={e => {
              e.preventDefault();
              if (
                this.state.active !== false &&
                this.state.value !== "" &&
                this.state.value !== item.loadingOrder &&
                !isNaN(this.state.value)
              ) {
                mutate({
                  variables: {
                    id: item.id,
                    loadingOrder:
                      this.state.value === "" ? null : this.state.value
                  }
                });
                this.setState({ active: false });
              } else this.setState({ active: false });
            }}
          >
            {this.state.active ? (
              <TextField
                borderless
                size="4"
                defaultValue={item.loadingOrder ? item.loadingOrder : ""}
                onChanged={value => this.setState({ value: value })}
                className="disabledLoadingOrder-container-TextField"
                inputClassName="disabledLoadingOrder-TextField"
              />
            ) : (
              <div style={{ width: "5px" }}>
                {item.loadingOrder ? item.loadingOrder : "__"}
              </div>
            )}
          </div>
        )}
      </Mutation>
    );
  }
}

export const UPDATE_LOADING_ORDER = gql`
  mutation($id: Int!, $loadingOrder: Int) {
    updateOrderById(
      input: { id: $id, orderPatch: { loadingOrder: $loadingOrder } }
    ) {
      order {
        id
        loadingOrder
      }
    }
  }
`;

export default LoadingOrderField;



// WEBPACK FOOTER //
// ./src/common/_LoadingOrderField.js